import React from "react";
import styled from "styled-components";
// import { CurrentUserContext } from "../../../CurrentUserContext";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import StartQuizButton from "../../Common/StartQuizButton";

const Wrapper = styled.div`
  display: flex;
  background: fixed repeat;
  background-image: url("/bg-pattern.jpg") !important;
  justify-content: center;
  align-items: center;
  gap: 4rem;
  width: 100vw;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: dodgerblue;
  border-radius: 10px;
  color: white;
  width: 20vw;
  padding: 1rem;
  max-height: 40vh;
  &:hover {
    box-shadow: inset 0 0 0 1.5px black;
    background-color: #a7d164;
  }
  a {
    text-decoration: none;
  }
  @media (max-width: 700px) {
    height: 30vh;
    width: 40vw;
    text-align: center;
  }
`;
const ImageWrapper = styled.div`
  display: flex;

  padding-bottom: 2em;
  @media (max-width: 500px) {
    padding: 0;
  }
`;
const OptionText = styled.h3`
  color: white;
  font-size: 1.6em;
  text-align: center;
  @media (max-width: 600px) {
    font-size: 1em;
  }
`;
const Image = styled.img`
  width: 4.5rem;
  height: 9rem;
  object-fit: contain;
`;

const CopyContainer = styled.div`
  display: flex;
  padding: 1rem;
  flex-direction: column;
  max-width: 30vw;
  max-height: 80vh;
  justify-content: center;
  align-items: center;
  line-height: 1.65rem;
  color: white;
  text-align: center;
  font-family: var(--font-family);
  @media (max-width: 700px) {
    height: fit-content;
    max-width: 90vw;
  }
`;

const ProfileCardRetired = ({ data }) => {
  const userData = data;
  const url = "retired-couple";
  return (
    <Wrapper>
      <Card name="card">
        <a href="/home">
          <ImageWrapper>
            <Carousel
              showArrows={false}
              showStatus={false}
              showThumbs={false}
              showIndicators={false}
              autoPlay={true}
              transitionTime={1000}
              swipable={false}
              infiniteLoop={true}
              interval={8000}
            >
              <Image src={`/${userData[1].images[0].src}`} alt="picture of a retired couple" />
              <Image src={`/${userData[1].images[1].src}`} alt="picture of a retired couple" />
              <Image src={`/${userData[1].images[2].src}`} alt="picture of a retired couple" />
              <Image src={`/${userData[1].images[3].src}`} alt="picture of a retired couple" />
            </Carousel>
          </ImageWrapper>
          <OptionText key={userData[1].name}>{userData[1].name}</OptionText>
        </a>
      </Card>
      <CopyContainer>
        <p>
          We’ve been happily married for many years, and saved when we could,
          but retirement is more expensive than we thought.{" "}
        </p>
        <br />
        <p>
          Our house still isn’t paid off and our credit cards get more action
          than we’d like.{" "}
        </p>
        <br />

        <p>
          We need answers to our questions and peace of mind about the future.
        </p>
        <StartQuizButton url={url} />
      </CopyContainer>
    </Wrapper>
  );
};

export default ProfileCardRetired;
